var _defs, _circle, _circle2, _circle3, _path, _circle4, _rect, _rect2, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep3Mobile01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 480 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7ebb42;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "STEP 3 mobile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 241.55,
    cy: 40.5,
    r: 22.06,
    transform: "translate(161.38 271.93) rotate(-80.41)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 76.65,
    cy: 40.5,
    r: 22.06
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 406.45,
    cy: 40.5,
    r: 24.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M406.45,65.65A25.15,25.15,0,1,1,431.6,40.5h0A25.19,25.19,0,0,1,406.45,65.65Zm0-48.3A23.15,23.15,0,1,0,429.6,40.5h0A23.18,23.18,0,0,0,406.45,17.35Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 406.45,
    cy: 40.5,
    r: 21.06
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 276.34,
    y: 39.5,
    width: 95.83,
    height: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 109.89,
    y: 39.5,
    width: 97.5,
    height: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79.37,46.77H76.89V37.19l-3,.92v-2l5.19-1.86h.26Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246,46.85h-8.58v-1.7l4.05-4.32a10.61,10.61,0,0,0,1.24-1.59,2.68,2.68,0,0,0,.4-1.29,2,2,0,0,0-.43-1.32,1.51,1.51,0,0,0-1.2-.47,1.62,1.62,0,0,0-1.33.58,2.31,2.31,0,0,0-.49,1.52h-2.49a4,4,0,0,1,.55-2.09,3.85,3.85,0,0,1,1.54-1.48,4.68,4.68,0,0,1,2.26-.54,4.49,4.49,0,0,1,3,.93,3.29,3.29,0,0,1,1.07,2.62,4.35,4.35,0,0,1-.48,1.9,10.37,10.37,0,0,1-1.65,2.24l-2.85,3H246Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M404.93,39.4h1.32a1.92,1.92,0,0,0,1.41-.47,1.77,1.77,0,0,0,.45-1.26,1.53,1.53,0,0,0-.45-1.18,2,2,0,0,0-2.44,0,1.26,1.26,0,0,0-.48,1h-2.49a3.06,3.06,0,0,1,.53-1.76,3.73,3.73,0,0,1,1.48-1.22,5.06,5.06,0,0,1,2.1-.43,4.67,4.67,0,0,1,3.11,1,3.24,3.24,0,0,1,1.13,2.62,2.66,2.66,0,0,1-.53,1.58,3.38,3.38,0,0,1-1.37,1.11,2.91,2.91,0,0,1,2.1,2.92A3.29,3.29,0,0,1,409.58,46a4.9,4.9,0,0,1-3.22,1,4.67,4.67,0,0,1-3.07-1,3.25,3.25,0,0,1-1.19-2.61h2.49a1.42,1.42,0,0,0,.52,1.15,2.22,2.22,0,0,0,2.7,0,1.6,1.6,0,0,0,.5-1.24c0-1.25-.69-1.88-2.06-1.88h-1.32Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3Mobile01);
export default __webpack_public_path__ + "static/media/STEP 3 mobile-01.c971865fa183104fce51d3a56580ca59.svg";
export { ForwardRef as ReactComponent };